export default __webpack_public_path__ + "static/media/heart-grey.507ca7b9.svg";